"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var section_repeater_1 = require("../../controls/section-repeater");
wp.customize.controlConstructor['epsilon-section-repeater'] = wp.customize.Control.extend({
    ready: function () {
        var control = this, id = jQuery(this.container).attr('id'), node = document.getElementById(id), observer = new MutationObserver(function (mutations) {
            var element = mutations[mutations.length - 1];
            if (jQuery(element.target).is(':visible') && !jQuery(element.target).hasClass('epsilon-section-repeater-initiated')) {
                jQuery(element.target).addClass('epsilon-section-repeater-initiated');
                new section_repeater_1.EpsilonSectionRepeater(control);
            }
        });
        if (this.container.is(':visible')) {
            this.container.addClass('epsilon-section-repeater-initiated');
            new section_repeater_1.EpsilonSectionRepeater(control);
        }
        if (null !== node) {
            observer.observe(node, { attributes: true, childList: false, attributeFilter: ['style'] });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/controls/section-repeater.ts
// module id = 20
// module chunks = 0